import { Box, Link, Typography } from "@mui/material";

import { Link as RouterLink } from "react-router-dom";

import { LEGAL_DOCUMENTS } from "../constants/legalDocuments";

export const renderLegalBody = (body) =>
    body.split("\n").map((line, i) => {
        if (line.startsWith("## ")) {
            return (
                <Typography
                    key={i}
                    sx={{ fontWeight: 600, fontSize: 15, mt: 2, mb: 0.5 }}
                >
                    {line.slice(3)}
                </Typography>
            );
        }
        if (line.startsWith("# ")) {
            return (
                <Typography
                    key={i}
                    sx={{ fontWeight: 700, fontSize: 16, mt: 3, mb: 1 }}
                >
                    {line.slice(2)}
                </Typography>
            );
        }
        if (line.startsWith("- ")) {
            const text = line.slice(2);
            const colon = text.indexOf(": ");
            return (
                <Box component="li" key={i} sx={{ fontSize: 14, mb: 0.75, ml: 2.5 }}>
                    {colon > -1 && colon < 60 ? (
                        <>
                            <strong>{text.slice(0, colon)}:</strong> {text.slice(colon + 2)}
                        </>
                    ) : (
                        text
                    )}
                </Box>
            );
        }
        return (
            <Typography key={i} sx={{ fontSize: 14, mb: 1, lineHeight: 1.6 }}>
                {line}
            </Typography>
        );
    });

const LegalLinks = ({ sx }) => (
    <Box
        component="footer"
        sx={{
            alignSelf: "stretch",
            mt: 4,
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: { xs: "center", md: "flex-end" },
            columnGap: 3,
            rowGap: 1,
            fontSize: 12,
            color: "var(--app-text-muted)",
            ...sx,
        }}
    >
        <Typography sx={{ fontSize: 12, color: "inherit" }}>
            © {new Date().getFullYear()} Sunfox Technologies Pvt. Ltd.
        </Typography>
        <Box
            sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: 2,
            }}
        >
            {LEGAL_DOCUMENTS.map((doc) => (
                <Link
                    key={doc.key}
                    component={RouterLink}
                    to={doc.path}
                    underline="hover"
                    sx={{ fontSize: 12, fontWeight: 600, color: "#5B5BE0" }}
                >
                    {doc.title}
                </Link>
            ))}
        </Box>
    </Box>
);

export default LegalLinks;